import { useCallback } from "react"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
import type { TrailVO, SuccessRateFilters } from "@/api"
// ==============================================
interface SituationArgs {
  // 需要显示的员工ID
  cardIds: string[]
  // 轨迹数据
  crmTrail?: TrailVO
  // 筛选条件
  screeningData?: SuccessRateFilters
}
function useSituation() {
  const [state, set] = useSetState<SituationArgs>({
    cardIds: [],
  })

  // 设置cardIds
  const setCardIds = useCallback(
    (ids: string[]) => {
      set({
        cardIds: ids,
      })
    },
    [set],
  )

  const setAllState = useCallback(
    (value: Partial<SituationArgs> | ((prevState: SituationArgs) => Partial<SituationArgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setCardIds,
    setAllState,
  }
}

export default createModel(useSituation)
